<template>
  <div class="iframe touch" @click.stop="$store.commit('actions/SET_IFRAME_URL', '')">
    <div class="iframe__inner">
      <!-- <div class="iframe__control-overlay"></div> -->
      <div style="position:relative;padding-top:max(50%,326px);height:0;width:100%;" @click.stop="">
        <iframe sandbox="allow-top-navigation allow-top-navigation-by-user-activation allow-downloads allow-scripts allow-same-origin" allowfullscreen="true" style="position:absolute;border:none;width:100%;height:100%;left:0;right:0;top:0;bottom:0;" :src="url"></iframe>
      </div>
      <div class="iframe-close touch" @click.stop="$store.commit('actions/SET_IFRAME_URL', '')">
        <fa :icon="['fas', 'times']" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['url'],

  watch: {
    $route () {
      this.$store.commit('actions/SET_IFRAME_URL', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.iframe {
  background: rgba(0, 0, 0, .7);
  bottom: 10rem;
  display: flex;    
  left: 0;
  position: absolute;
  right: 32.5rem;
  top: 0;
  // width: 100%;
  z-index: 200;

  .iframe-close {
    background: #4d555b;
    border-radius: 50%;
    bottom: 2rem;
    box-shadow: 0.15em 0.25em 0.35em rgba(0, 0, 0, 0.45);
    height: 5rem;
    left: 50%;
    position: absolute;
    transform: translateX(-50%);
    width: 5rem;
    z-index: 10;

    svg {
      font-size: 2.6rem;
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
    }
  }  

  &__inner {
    margin: auto 0 0;
    padding: 10rem;
    width: 100%;
  }

  &__control-overlay {
    background: #1e1e1e;
    bottom: 10rem;
    height: 45px;
    left: 10rem;
    position: absolute;
    right: 10rem;
    overflow: hidden;
    z-index: 10;

    &::before {
      background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAABaCAQAAADTVfQ2AAAAPUlEQVR4AU2MAQoAIBDCzuv+/+YQERZDtqDGRztT4hTmwgWS24xMpWseXM7eZyHMQ4bLP3WIObxdOFdIJT+cCQFTpiGPbAAAAABJRU5ErkJggg==);
      background-repeat: repeat-x;
      content: '';
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      height: 89px;
      pointer-events: all;
    }
  }
}
</style>